module.exports = "/_next/static/resources/life1-381d7dd9277a3b4ffc5c65d9369976cc.webp";